import React, { FC, useEffect, useState } from "react";
import TextInput from "../../components/UI/Inputs/TextInput";
import CustomButton from "../../components/UI/Buttons/CustomButton";
import { TForgotPassFormValues } from "../../models/form";
import { forgotPasswordThunk } from "../../store/auth/thunks";
import {
  useAppDispatch as useDispatch,
  useAppSelector as useSelector,
} from "../../store";
import { NON_AUTH_ROUTE } from "../App/routes";
import { useFormik } from "formik";
import { createValidationSchema } from "../../utils/createValidationSchema";
import { Link } from "react-router-dom";
import ErrorMessage from "../../components/UI/Tooltips/ErrorMessage";
import { isFulfilled } from "@reduxjs/toolkit";
import { resetAuthErrorAction } from "../../store/auth/slice";

interface ForgotPasswordProps {}

const ForgotPassword: FC<ForgotPasswordProps> = () => {
  const dispatch = useDispatch();
  const error = useSelector((state) => state.auth.error);
  const inProgress = useSelector((state) => state.auth.inProgress);

  useEffect(() => {
    dispatch(resetAuthErrorAction())
  }, [dispatch])

  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false);

  // submit the form for forgotPassword
  const { handleSubmit, errors, touched, handleChange } = useFormik({
    validationSchema: createValidationSchema("forgotPassword"),
    initialValues: {
      email: "",
    },
    onSubmit: async (values: TForgotPassFormValues) => {
      const payload = { ...values };
      try {
        const result = await dispatch(forgotPasswordThunk(payload));
        if (isFulfilled(result)) {
          setShowSuccessMessage(!false);
        }
      } catch (error) {
        throw new Error(
          "Could not connect to services at the moment. Please try again. Thanks."
        );
      }
    },
  });

  return (
    <>
      <div
        className="fs-22 fw-400 text-black mt-20"
        data-testid="forgot-password"
      >
        Forgot Password
      </div>
      <div>Enter your email and we will send you a reset link</div>
      <form
        className="d-flex flex-column gap-20"
        onSubmit={handleSubmit} // Binds Formik's submit handler to the form
      >
        <TextInput
          type="text"
          field={"email"}
          label={"Email"}
          onChange={handleChange}
          touched={touched.email!}
          error={errors.email}
          placeholder={" " + ""}
        />
        {error && (
          <ErrorMessage message={error?.errors?.email || error?.message} />
        )}
        <div className="d-flex flex-column gap-20 align-items-center">
          <CustomButton
            isLoading={inProgress}
            contentClass={"d-flex"}
            type="submit"
            variant="primary"
            className="fw-600 btn-theme bg-teal text-black min-w-250px "
          >
            Submit
          </CustomButton>
          <div className="fs-13 text-grey-medium">
            <Link to={NON_AUTH_ROUTE.LOGIN} className="text-grey-medium">
              Go Back
            </Link>
          </div>
        </div>
        {showSuccessMessage && (
          <div
            className="d-flex flex-column align-items-center"
            style={{ color: "#34ada3" }}
          >
            The email has been sent successfully!
          </div>
        )}
      </form>
    </>
  );
};

export default ForgotPassword;
